export const DATE_FORMAT = 'yyyy-MM-dd';

export const REVERSED_DATE_FORMAT = 'dd-MM-yyyy';

export const REVERSED_SLASHED_DATE_FORMAT = 'dd/MM/yyyy';

export const DOT_DATE_FORMAT = 'dd.MM.yyyy';

export const TABLE_DATE_FORMAT = 'dd.MM.yyyy HH:mm';

export const ACTIVITY_DATE_FORMAT = 'dd.MM.yyyy HH:mm:ss';

export const TIME_DOT_DATE_FORMAT = 'HH:mm:ss dd.MM.yyyy';

export const ISO_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

export const FULL_HOUR_DATE_FORMAT = 'dd/MM/yyyy HH:00';

export const DOT_HOUR_DATE_FORMAT = 'dd.MM.yyyy HH:mm';

export const FULL_HOUR_MINUTE_DATE_FORMAT = 'dd/MM/yyyy HH:mm';
export const SHORT_MONTH_DATE_FORMAT = 'MMM dd, yyyy';

export const HH_MM_TIME_FORMAT = 'HH:mm';
